
  console.log("✅ Polling started to access iframe and copy coupon code...");

  const checkInterval = setInterval(() => {
    const iframe = document.querySelector("iframe");

    if (!iframe) {
      console.log("❌ Iframe not found yet");
      return;
    }

    let iframeDoc;
    try {
      iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
    } catch (err) {
      console.error("❌ Cross-origin access denied:", err);
      clearInterval(checkInterval);
      return;
    }

    if (!iframeDoc) {
      console.log("❌ iframe content not ready");
      return;
    }

    const codeDiv = iframeDoc.querySelector(".bitespeedPhoneNumber");

    if (codeDiv && codeDiv.textContent.trim()) {
      const couponCode = codeDiv.textContent.trim();

      navigator.clipboard.writeText(couponCode)
        .then(() => {
          console.log("✅ Coupon copied from iframe:", couponCode);
        })
        .catch((err) => {
          console.error("❌ Failed to copy from iframe:", err);
        });

      clearInterval(checkInterval);
      console.log("🛑 Polling stopped after successful copy");
    } else {
      console.log("⏳ Waiting for .bitespeedPhoneNumber inside iframe...");
    }
  }, 500);